import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { fmtDate } from "../lib/status";
import { Mail } from "lucide-react";

export default function CustomerNotifications() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/customer/notifications").then((r) => setItems(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-6" data-testid="portal-notifications-page">
      <div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold">Notifications</h1>
        <p className="text-slate-600 mt-1">Every email a business has sent you about your bookings.</p>
      </div>

      <div className="rounded-xl border border-slate-200 bg-white">
        {loading && <div className="p-6 text-slate-500">Loading…</div>}
        {!loading && items.length === 0 && (
          <div className="p-10 text-center text-slate-500" data-testid="portal-notifications-empty">
            <Mail className="w-8 h-8 mx-auto text-slate-400" />
            <p className="mt-2">No notifications yet.</p>
          </div>
        )}
        <ul className="divide-y divide-slate-100">
          {items.map((n) => (
            <li key={n.id} className="p-4" data-testid={`portal-notification-${n.id}`}>
              <div className="flex items-start gap-2">
                <Mail className="w-4 h-4 text-slate-500 mt-0.5" />
                <div className="min-w-0 flex-1">
                  <div className="font-medium">{n.subject}</div>
                  <div className="text-xs text-slate-500 mt-0.5">{fmtDate(n.created_at)} · {n.notification_type}</div>
                  {n.message_body && (
                    <p className="mt-2 text-sm text-slate-700 whitespace-pre-line">{n.message_body}</p>
                  )}
                  {n.link && (
                    <a href={n.link} className="mt-2 inline-block text-xs font-mono break-all text-[#1B4332] hover:underline">
                      {n.link}
                    </a>
                  )}
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
